/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon64Regular = forwardRef('FoodDrinkAlcoGlassWineIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M17.5 19a1.5 1.5 0 0 0 0 3h29a1.5 1.5 0 0 0 0-3h-29Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 11.5A5.5 5.5 0 0 1 15.5 6h33a5.5 5.5 0 0 1 5.5 5.5V20c0 11.646-9.05 21.179-20.5 21.95V56h13a1.5 1.5 0 0 1 0 3h-29a1.5 1.5 0 0 1 0-3h13V41.95C19.05 41.179 10 31.646 10 20v-8.5ZM51 20c0 10.49-8.5 18.994-18.989 19h-.022C21.5 38.994 13 30.49 13 20v-8.5A2.5 2.5 0 0 1 15.5 9h33a2.5 2.5 0 0 1 2.5 2.5V20Z" })));
});
